import './NavigationController.css';
import {useEffect, useState} from 'react';
import {useParams, useNavigate, useLocation} from "react-router-dom";

//The Navigation Controller is intended to work similar to the NavigationController component in iOS.
//It will display a list of navigation items in a left-hand navbar, and when one is clicked, it will display the content of that item.
//The navigation items are passed in as props along with their content.
//The navigation items contain a "visible" prop which determines when the item should be displayed.
const NavigationController = ({navigationItems, enrolmentId, initialItem}) => {
    const location = useLocation();
    const params = useParams();
    const navigate = useNavigate();
    const [activeItem, setActiveItem] = useState(initialItem || Object.keys(navigationItems)[0]);



    useEffect(() => {
        console.log(`initial item change ${initialItem}`);
        if (!initialItem || !navigationItems[initialItem]) {
            return;
        }
        if (activeItem !== initialItem) {
            setActiveItem(initialItem);
        }
    }, [initialItem, navigationItems]);




    //Update the address bar so you get a direct link to the current view
    useEffect(() => {
        if (!enrolmentId || !activeItem) {
            return;
        }
        //let item = params.item || "";
        if (params.id !== enrolmentId || params.item !== activeItem) {
            const url = "/enrolment/" + enrolmentId + "/" + activeItem;
            console.log(`!@! -----------------`);
            console.log(`!@! url: ${url}`);
            console.log(`!@! location.pathname: ${location.pathname}`);
            console.log(`!@! location.pathname.replaceAll("%20", " "): ${location.pathname.replaceAll("%20", " ")}`);
            console.log(`!@! params.id: ${params.id}`);
            console.log(`!@! params.item: ${params.item}`);
            console.log(`!@! enrolmentId: ${enrolmentId}`);
            console.log(`!@! activeItem: ${activeItem}`);
            console.log(`!@! initialItem: ${initialItem}`);
            console.log(`!@! -----------------`);
            if (!location.pathname.replaceAll("%20", " ").includes(url)) {
                navigate(url);
            }
            //window.history.replaceState("", "Enrolment", "/enrolment/" + enrolmentId + "/" + activeItem);
        }
    }, [activeItem, enrolmentId]);

    useEffect(() => {
        if (!navigationItems) {
            return;
        }
        if (!Object.keys(navigationItems).includes(activeItem)) {
            setActiveItem(Object.keys(navigationItems)[0]);
        }
    }, [navigationItems]);
    return (
        <div className={'navigation-controller'}>
            <div className={'navigation-controller__navbar'}>
                {Object.keys(navigationItems).map((item, index) => {
                    if (!navigationItems[item].props.visible) return null;
                    return (
                        <div key={index}
                             className={'navigation_controller__navigation_item ' + (activeItem === item ? 'active' : '')}
                             onClick={() => setActiveItem(item)}
                        >
                            {item}
                        </div>
                    )
                })}
            </div>
            <div className={'navigation-controller__content'}>
                {navigationItems[activeItem]}
            </div>
        </div>
    )
}

export default NavigationController;